import { defaultProcessText } from 'app/utility/textProcessing';
import { IImage } from 'app/interfaces/common';
import classNames from 'classnames';
import ImageBg from 'app/components/common/ImageBg';

export interface IBenefitCardProps {
  image?: IImage | null;
  title?: string | null;
  description?: string | null;
  className?: string;
}

export default function BenefitCard({
  image,
  title = '',
  description = '',
  className
}: IBenefitCardProps) {
  return (
    <div
      className={classNames(
        'group rounded-xl flex flex-col sm:grid sm:grid-cols-12 gap-5 sm:gap-2 md:gap-3 xl:gap-4 p-3 sm:p-1 bg-sand-dark xl:bg-transparent xl:hover:bg-sand-dark transition-colors duration-300',
        className
      )}
    >
      <div className="sm:col-span-5">
        <div className="relative pb-[60%] md:pb-[70%] xl:pb-[152%] bg-brown rounded min-h-full overflow-hidden isolate">
          {!!image?.url && (
            <div className="absolute inset-0 rounded group-hover:scale-105 transition-transform duration-700">
              <ImageBg
                src={image.url}
                alt={image.alt || ''}
                fill
                placeholderDataURL={image.placeholder_data_url}
                sizes="(min-width: 768px) 50vw, (min-width: 1280px) 33vw, 100vw"
                className="object-cover rounded"
              />
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col justify-between gap-8 sm:col-span-7 sm:pl-8 sm:py-2 md:pr-6 md:py-4 xl:py-10 xl:opacity-0 xl:group-hover:opacity-100 transition-opacity duration-300">
        {!!title && (
          <div
            className="text-h1"
            dangerouslySetInnerHTML={{ __html: defaultProcessText(title) }}
          ></div>
        )}
        {!!description && (
          <div
            className="text-p3 flex flex-col gap-[1em]"
            dangerouslySetInnerHTML={{
              __html: defaultProcessText(description)
            }}
          ></div>
        )}
      </div>
    </div>
  );
}
